module.exports = __webpack_public_path__ + "img/newland150x56.f4cd4b7f.jpg";